// Catálogo único de permisos de Nina Ferre. Cada clave existe en el modelo User del back
// y viaja en el token; el back revisa las mismas claves en cada ruta.
export const SECCIONES_PERMISOS = [
  {
    seccion: "Caja", icono: "fas fa-cash-register", tienda: true,
    items: [
      { k: "posVender", label: "Vender", desc: "Cobrar en la caja" },
      { k: "posCorte", label: "Corte de caja", desc: "Cerrar y reimprimir cortes" },
      { k: "posVentas", label: "Consultar ventas", desc: "Listado y reimpresión de tickets" },
      { k: "posCancelar", label: "Cancelar ventas", desc: "Solo antes del corte" },
      { k: "posVenderSinExistencia", label: "Vender sin existencia", desc: "Deja vender aunque el sistema diga 0; el inventario queda en negativo" },
      { k: "posDevoluciones", label: "Devoluciones y cambios", desc: "Regresa dinero o hace cambio" },
      { k: "posCaja", label: "Gastos, retiros y fondo", desc: "Salidas y entradas de efectivo de la caja" },
    ],
  },
  {
    seccion: "Inventario de tienda", icono: "fas fa-warehouse", tienda: true,
    items: [
      { k: "posInventario", label: "Ver inventario y movimientos", desc: "Existencias y kardex" },
      { k: "posCostos", label: "Ver costos", desc: "Costo y valor del inventario" },
      { k: "posEntradas", label: "Dar entradas de inventario", desc: "Alta de mercancía con costo" },
      { k: "posCancelarEntradas", label: "Cancelar entradas", desc: "Regresa lo que se dio de alta" },
      { k: "posEtiquetas", label: "Imprimir etiquetas", desc: "Código de barras por talla y color" },
    ],
  },
  {
    seccion: "Traspasos", icono: "fas fa-exchange-alt", tienda: true,
    items: [
      { k: "posTraspasos", label: "Enviar traspasos", desc: "Sacar mercancía hacia otra tienda" },
      { k: "posRecibir", label: "Recibir traspasos", desc: "Confirmar lo que llega de otra tienda" },
    ],
  },
  {
    seccion: "Dirección de tiendas", icono: "fas fa-chart-line", tienda: true,
    items: [
      { k: "posReportes", label: "Reportes de ventas", desc: "Con alcance de su tienda o de todas" },
      { k: "posPromociones", label: "Promociones", desc: "Crear y editar (requiere todas las tiendas)" },
      { k: "posTiendas", label: "Tiendas", desc: "Alta y edición (requiere todas las tiendas)" },
    ],
  },
  {
    seccion: "Modelos", icono: "fas fa-tshirt",
    items: [
      { k: "menu_articulos", label: "Ver modelos y catálogos", desc: "Líneas, marcas, colores, tallas…" },
      { k: "articulos_create", label: "Crear y editar modelos", desc: "" },
    ],
  },
  {
    seccion: "Empleados", icono: "fas fa-users",
    items: [
      { k: "menu_empleados", label: "Ver empleados", desc: "" },
      { k: "empleados_create", label: "Alta y edición de empleados", desc: "Crea su usuario" },
      { k: "menu_puestos", label: "Ver puestos", desc: "" },
      { k: "puestos_create", label: "Crear puestos", desc: "" },
    ],
  },
  {
    seccion: "Usuarios y bitácora", icono: "fas fa-user-lock",
    items: [
      { k: "menu_usuarios", label: "Ver usuarios", desc: "" },
      { k: "usuarios_permisos", label: "Editar permisos", desc: "Permisos, tienda y alcance" },
      { k: "menu_logs", label: "Bitácora", desc: "Quién hizo qué" },
    ],
  },
];

export const CLAVES_PERMISOS = SECCIONES_PERMISOS.flatMap((s) => s.items.map((i) => i.k));

// Plantillas rápidas para no marcar casilla por casilla
export const PLANTILLAS = [
  { nombre: "Cajera", alcance: "tienda", claves: ["posVender", "posCorte", "posVentas", "posInventario", "posRecibir", "posCaja"] },
  { nombre: "Encargada de tienda", alcance: "tienda", claves: ["posVender", "posVenderSinExistencia", "posCorte", "posVentas", "posCancelar", "posDevoluciones", "posInventario", "posEntradas", "posEtiquetas", "posTraspasos", "posRecibir", "posCaja", "posReportes"] },
  { nombre: "Almacén / inventarios", alcance: "master", claves: ["posInventario", "posCostos", "posEntradas", "posCancelarEntradas", "posEtiquetas", "posTraspasos", "posRecibir", "menu_articulos", "articulos_create"] },
  { nombre: "Dirección (todo)", alcance: "master", claves: null },
];

export const ALCANCES = {
  "": "Sin acceso a tiendas",
  tienda: "Solo su tienda",
  master: "Todas las tiendas",
};
